/**
 * Normalizes Romanian text by removing diacritics for comparison
 * București -> bucuresti
 * Țară -> tara
 */
export function normalizeRomanianText(text: string): string {
  if (!text) return '';
  
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/ă/g, 'a')
    .replace(/â/g, 'a')
    .replace(/î/g, 'i')
    .replace(/ș/g, 's')
    .replace(/ț/g, 't')
    .replace(/Ă/g, 'a')
    .replace(/Â/g, 'a')
    .replace(/Î/g, 'i')
    .replace(/Ș/g, 's')
    .replace(/Ț/g, 't');
}

/**
 * Checks if a location string matches a city name (diacritic-insensitive)
 */
export function locationMatchesCity(location: string, cityName: string): boolean {
  const normalizedLocation = normalizeRomanianText(location);
  const normalizedCity = normalizeRomanianText(cityName);
  return normalizedLocation.includes(normalizedCity);
}
